import { ScreenFrame, type ScreenFrameProps } from '@beatq/shared';

function merchantShowScreenId(explicit?: boolean): boolean {
  if (explicit != null) return explicit;
  try {
    return import.meta.env.DEV && localStorage.getItem('beatq.qa.showScreenIds') === '1';
  } catch {
    return false;
  }
}

/** Merchant shell frame — hides SCR IDs unless QA flag is set in dev. */
export function MerchantScreenFrame(props: ScreenFrameProps) {
  const showScreenId = merchantShowScreenId(props.showScreenId);
  return <ScreenFrame {...props} showScreenId={showScreenId} />;
}
